import { computed, defineComponent } from 'vue';
import { usePaymentStore } from '@/store/modules/payment';
import { storeToRefs } from 'pinia';
import WalletAddress from '@/components/payment/WalletAddress.vue';
import BankDetails from '@/components/payment/BankDetails.vue';
import OrderSent from '@/components/payment/OrderSent.vue';
import GenerateWalletDetails from '@/components/sell/GenerateWalletDetails.vue';
import { PaymentTypes } from '@/types/payment';
import SellOrderSent from '@/components/sell/SellOrderSent.vue';
import SellWalletDetails from '@/components/sell/SellWalletDetails.vue';
import MobileMoneyDetails from '@/components/payment/MobileMoneyDetails.vue';
import AuthoriseMinipay from '@/components/sell/AuthoriseMinipay.vue';
import MinipayViewAddress from '@/components/sell/MinipayViewAddress.vue';
import MinipayAuthorizationFailed from '@/components/sell/MinipayAuthorizationFailed.vue';
import MinipayTransactionError from '@/components/sell/MinipayTransactionError.vue';
import SavePayoutAccountPrompt from '@/components/payoutAccounts/SavePayoutAccountPrompt.vue';
export default defineComponent({
    name: 'PaymentView',
    props: {},
    components: {
        WalletAddress,
    },
    setup() {
        const paymentStore = usePaymentStore();
        const { currentStep } = storeToRefs(paymentStore);
        // will have all payment component available regardless of whether partner has access to sell or not,
        // this is so the user can still see wallet details etc. for their old sell txs regardless of the partner they have logged in with
        const stepsList = [
            {
                name: PaymentTypes.PaymentSteps.PAYMENT_1,
                component: WalletAddress,
            },
            {
                name: PaymentTypes.PaymentSteps.PAYMENT_2,
                component: BankDetails,
            },
            {
                name: PaymentTypes.PaymentSteps.PAYMENT_3,
                component: MobileMoneyDetails,
            },
            {
                name: PaymentTypes.PaymentSteps.PAYMENT_4,
                component: OrderSent,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_2,
                component: GenerateWalletDetails,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_3,
                component: SellWalletDetails,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_4,
                component: SellOrderSent,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_5,
                component: AuthoriseMinipay,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_6,
                component: MinipayViewAddress,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_7,
                component: MinipayAuthorizationFailed,
            },
            {
                name: PaymentTypes.SellPaymentSteps.PAYMENT_9,
                component: MinipayTransactionError,
            },
            {
                name: PaymentTypes.SellPaymentSteps.SAVE_PAYOUT_ACCOUNT,
                component: SavePayoutAccountPrompt,
            },
        ];
        const activeTab = computed(() => stepsList.find(item => item.name === currentStep.value).component);
        return {
            currentStep,
            stepsList,
            activeTab,
        };
    },
});
